import { ListHeader } from 'components/molecules/ListHeader';

export const MenuCategoryListHeader = () => (
  <ListHeader
    columns={[
      '',
      'カテゴリーID',
      'カテゴリー名',
      'メニューID',
      'メニュー名',
      '公開範囲',
      '説明',
    ]}
    templateColumns="0.5fr 1fr 2fr 1fr 3fr 2fr 3fr"
  />
);
